// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"LoadingOverlayLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/LoadingOverlayLayout/LoadingOverlayLayout.scss
 ** module id = 952
 ** module chunks = 1
 **/